/**
 * On refresh/?variant=, show the selected variant image (not the first gallery slide).
 * Loaded outside bundle-head.js so it works when use_bundles is on.
 */
(function () {
  function sync(el) {
    if (!el || typeof el.updateMedia !== 'function') return;
    if (!el.currentVariant || !el.currentVariant.featured_media) return;
    var layout = el.sectionLayout || el.dataset.sectionLayout;
    if (layout !== 'product' && layout !== 'quick-view') return;

    var attempt = function (triesLeft) {
      var block = el.closest('.prd-block');
      var gallery = block && block.querySelector('product-gallery');
      var main = block && block.querySelector('.js-product-main-carousel');
      if (gallery && main && typeof gallery.filter === 'function') {
        try {
          el.updateMedia();
        } catch (e) {}
        return;
      }
      if (triesLeft > 0) setTimeout(function () { attempt(triesLeft - 1); }, 50);
    };

    requestAnimationFrame(function () { attempt(12); });
  }

  function run() {
    document.querySelectorAll('variant-radios, variant-selects, variant-select').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  } else {
    setTimeout(run, 0);
  }
  window.addEventListener('load', function () { setTimeout(run, 80); });
})();
